export default "__VITE_ASSET__21a2d989__$_?component__"